import store from '@/store'

/**
 * Выставление состояния загрузки приложения
 * @todo Нужен ли метод?
 * @param {*} loading
 */
function setAppLoading(loading) {
  store.commit('app/layout/setAppLoading', loading)
}

function is_dark(color) {
  if (color.indexOf("#") === 0) {
    color = color.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (color.length === 3) {
    color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
  }
  if (color.length !== 6) {
    throw new Error("Invalid HEX color.");
  }
  const r = parseInt(color.slice(0, 2), 16);
  const g = parseInt(color.slice(2, 4), 16);
  const b = parseInt(color.slice(4, 6), 16);
  return r * 0.299 + g * 0.587 + b * 0.114 < 186;
}

export { setAppLoading, is_dark }



// WEBPACK FOOTER //
// ./src/helpers/app/index.js